<template lang="pug">
  router-link(:to="to", v-if="to").ButtonSimple
    slot
  a(v-else :href="href").ButtonSimple
    slot
</template>

<script>

export default {
  props: ['to', 'href']

}

</script>

<style lang="stylus" scoped>

  .ButtonSimple
    // padding 10px 40px
    padding 4px 25px
    margin auto
    height 40px
    text-transform uppercase
    color $beige
    width fit-content
    display block
    line-height 40px
    text-decoration none
    border 1px solid $beige
    border-radius 50px
    cursor pointer
    white-space: nowrap;
    overflow hidden
    position relative
    backface-visibility: hidden;
    transition: border-color 0.3s, color 0.3s, transform 1s, opacity 0.8s ;
    transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
    // transition color 0.8s $ease, border-color 0.8s $ease, background-color 0.8s $ease, transform 1s $ease, opacity 0.8s $ease

    &:before

      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 150%;
      height: 100%;
      background: white;
      z-index: -1;
      transform: rotate3d(0, 0, 1, -45deg) translate3d(0, 3em, 0);
      transform-origin: 100% 0%;
      transition: transform 0.3s, opacity 0.3s, background-color 0.3s;

    &_black

      border-color $black
      color $beige
      background-color $black
      padding-top 0px
      padding-bottom 0px

      &:before

        background $grey-1

    @media $mq_s_only
      font-size 14px
      white-space: normal;
      padding 10px 25px

    svg
      width 15px
      margin-left 15px

    &-with-background
      background-color rgba(0,0,0,0.5)

    &:hover, &.hover

      border-color transparent
      color $black
      // zoom : 98%;
      transform translateZ(0) perspective(1px)

      &:before

        opacity: 1;
        background-color: $beige;
        transform: rotate3d(0, 0, 1, 0deg);
        transition-timing-function: cubic-bezier(0.23, 1, 0.32, 1);

    &:focus

      transform translateZ(0) perspective(1px)
      opacity 0.5

</style>
